import { render, staticRenderFns } from "./DoctorPriceTabs.vue?vue&type=template&id=c6479476&"
import script from "./DoctorPriceTabs.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorPriceTabs.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6479476')) {
      api.createRecord('c6479476', component.options)
    } else {
      api.reload('c6479476', component.options)
    }
    module.hot.accept("./DoctorPriceTabs.vue?vue&type=template&id=c6479476&", function () {
      api.rerender('c6479476', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/components/DoctorPriceTabs.vue"
export default component.exports